











import UniversalSelectInput from "./UniversalSelectInput.vue";
import { createComponent, computed } from "@vue/composition-api";

type LabeledOption = {
  value: any;
  label: string;
};

interface Props {
  value: any;
  options: LabeledOption[];
}

export default createComponent<Props>({
  components: { UniversalSelectInput },
  props: {
    value: { required: true },
    options: { required: true, type: Array },
  },
  setup(props, ctx) {
    function onInput(option: LabeledOption) {
      ctx.emit("input", option.value);
    }
    const selectedOption = computed(() =>
      props.options.find((o) => o.value === props.value),
    );

    return { onInput, selectedOption };
  },
});
